import { useContext } from 'react';

import { AuthGuardContext } from 'context/AuthGuardContext';

export default function useAuthGuard() {
  return useContext(AuthGuardContext);
}
